import api from "./api";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const mediaUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND}${u}` : u || "");

export async function uploadImage(file, visibility = "private") {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post(`/uploads?visibility=${visibility}`, fd);
  return data.url;
}
